import loadable from '@loadable/component'

export default {
    // '/download': loadable(() => import('./ZhongheDownload')),
    '/download': loadable(() => import('./ZhongheDownloadNew')),
    '/:type/mall/power/secret': loadable(() => import('./Secret')),
    '/:type/mall/power/protocol': loadable(() => import('./Protocol')),
}
